export const profile = {
    text1: "Informacje o moim koncie",
    text2: "Dane osobowe",
    text3: "Imię i nazwisko",
    text4: "Numer dokumentu",
    text5: "Telefon",
    text6: "Kraj",
    text7: "Adres e-mail",
    text8: "Zaktualizuj dane",
    text9: "Dane dostępowe",
    text10: "Hasło",
    text11: "Potwierdź hasło",
    text12: "Zaktualizuj hasło",

    // Corrections
    p1: "Ustawienia konta",
    p2: "Dane profilu",
    p3: "Logowanie i bezpieczeństwo",
    p4: "Dane do faktury",
    p5: "Główny adres e-mail",
    p6: "Na ten adres będą wysyłane wszystkie wiadomości od WACheckin",
    p7: "Informacje o koncie",
    p8: "Zarządzaj danymi swojego konta.",
    p9: "Imię i nazwisko",
    p10: "Wpisz imię i nazwisko",
    p11: "Numer dokumentu",
    p12: "Wpisz numer dokumentu",
    p13: "Telefon",
    p14: "Wpisz numer telefonu",
    p15: "Logowanie i bezpieczeństwo",
    p16: "Zaktualizuj hasło i zabezpiecz swoje konto.",
    p17: "Hasło do konta",
    p18: "Ostatnia aktualizacja:",
    p19: "Zmień hasło",
    p20: "Dane do faktury",
    p21: "Zarządzaj danymi swojego konta.",
    p22: "Nazwa firmy",
    p23: "Wpisz nazwę firmy",
    p24: "NIP",
    p25: "Wpisz numer NIP",
    p26: "Adres do faktury",
    p27: "Wpisz adres do faktury",
    p28: "Kraj",
    p29: "Województwo",
    p30:'Kod pocztowy',
    p31:`Brak danych do faktury`,
    p32:`Dane do faktury zostaną uzupełnione automatycznie po wykupieniu subskrypcji.`,
};
